import { Offcanvas } from "react-bootstrap";
import BasicDetails from "../Login/Register_Enterprenuer/Reg_Enterprneur_Investment/BasicDetails";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import "./updateModal.scss";
import VerifyOTP from "../Vertification/verification";
import { ACCOUNT_TYPE, LOGIN_TYPE } from "../../assets/constants/constants";
import BusinessDetails from "../Login/Register_Enterprenuer/Reg_Enterprneur_Investment/BusinessDetails";
import DocumentDetails from "../Login/Register_Enterprenuer/Reg_Enterprneur_Investment/DocumentsDetails";
import FinanceDetails from "../Login/Register_Enterprenuer/Reg_Enterprneur_Investment/FinanceDetails";
import BasicDetails_INVESTOR from "../Login/Registration_INVESTOR/BasicDetails_INVESTOR";
import { RegistrationIds } from "../../assets/interface/primeSharkWebsite_interface";
import DocumentsDetails_INVESTOR from "../Login/Registration_INVESTOR/DocumentsDetails_INVESTOR";
import FinanceDetails_INVESTOR from "../Login/Registration_INVESTOR/FinanceDetails_INVESTOR";
import BusinessDetailsWantToGrow from "../Login/Register_Enterprenuer/Reg_Enterpreneur_WantToGrow/BasicDetailsWantToGrow";
import AdditionalInfoWantToGrow from "../Login/Register_Enterprenuer/Reg_Enterpreneur_WantToGrow/AdditionalInfoWantToGrow";
import DocumentDetailsWantToGrow from "../Login/Register_Enterprenuer/Reg_Enterpreneur_WantToGrow/DocumentsDetails_WANTTOGROW";
import BasicDetailsWantToSell from "../Login/Register_Enterprenuer/Reg_Enterprneur_WantToSell/BasicDetailsWantToSell";
import BusinessDetails_WantToSell from "../Login/Register_Enterprenuer/Reg_Enterprneur_WantToSell/BusinessDetails_WantToSell";
import DocumentDetailsWantToSell from "../Login/Register_Enterprenuer/Reg_Enterprneur_WantToSell/DocumentsDetails_WANTTOSELL";

import { useParams } from "react-router-dom";

interface PropsData {
  showMissingFieldsModal: boolean;
  setShowMissingFieldsModal: (flag: boolean) => void;
  section: string;
  fields_to_improve: any;
  account_type?: string;
  login_type?: string;
}

const UpdateProfileInfoModal = ({
  showMissingFieldsModal,
  setShowMissingFieldsModal,
  section,
  fields_to_improve,
  account_type: account_type_prop,
  login_type: login_type_prop,
}: PropsData) => {
  const params = useParams();
  const activeLoginTypes = useSelector(
    (state: any) => state?.items?.storeActiveLoginType,
  );

  const rawAccountType = (
    account_type_prop ||
    params?.account_type ||
    activeLoginTypes?.account_type ||
    ""
  ).toLowerCase();

  const rawLoginType = (
    login_type_prop ||
    params?.login_type ||
    activeLoginTypes?.loginType ||
    ""
  ).toLowerCase();

  let account_type = "INVESTMENT";
  if (
    rawAccountType === "want-to-grow" ||
    rawAccountType === "want_to_grow" ||
    rawAccountType === "global-connect" ||
    rawAccountType === "global_connect"
  ) {
    account_type = "want_to_grow";
  } else if (
    rawAccountType === "want-to-sell" ||
    rawAccountType === "want_to_sell" ||
    rawAccountType === "business-exchange" ||
    rawAccountType === "business_exchange"
  ) {
    account_type = "want_to_sell";
  } else if (
    rawAccountType === "investment" ||
    rawAccountType === "capital-bridge" ||
    rawAccountType === "capital_bridge"
  ) {
    account_type = "INVESTMENT";
  } else {
    account_type = rawAccountType;
  }

  let login_type = rawLoginType;
  const [emailVerified, setEmailVerified] = useState(false);
  const registrationIds = useSelector(
    (state: any) => state?.items?.CurrentRegistrationIds,
  );
  const [emailVarificationRequired, setEmailVerficationRequired] =
    useState(false);
  const [contactInfo, setContactInfo] = useState({
    mobile_number: "",
    email: "",
    dial_code: "",
    country_code: "",
  });
  const [show, setShow] = useState(false);

  const [impIds, setImpIds] = useState({
    uuid: registrationIds?.uuid,
    business_uuid: registrationIds?.business_uuid,
    account_type: account_type,
    login_type: login_type,
  });
  useEffect(() => {
    setImpIds((prev: any) => ({
      ...prev,
      account_type: account_type,
      login_type: login_type,
    }));
  }, [account_type, login_type]);

  return (
    <React.Fragment>
      <Offcanvas
        show={showMissingFieldsModal}
        onHide={() => setShowMissingFieldsModal(false)}
        placement="end"
        className="update-profile-drawer"
        backdropClassName="custom-backdrop"
        backdrop={true}
      >
        <Offcanvas.Header closeButton>
          <div>
            <h4 className="fw-bold mb-1">Complete Your Profile</h4>

            <p className="text-muted mb-0">
              Please update the missing information.
            </p>
          </div>
        </Offcanvas.Header>

        <Offcanvas.Body>
          {account_type?.toLocaleLowerCase() ===
            ACCOUNT_TYPE.INVESTMENT?.toLocaleLowerCase() &&
            section === "basic_details" && (
              <BasicDetails
                impIds={impIds}
                from="FROM_PROFILE_ANALYSIS"
                fields_to_improve={fields_to_improve}
                handleNext={(
                  data: any,
                  email: string,
                  mobile_number: string,
                  dial_code: string,
                  // mobile_verified_at1: any,
                  email_verified_at1: any,
                  country_code: string,
                ) => {
                  setContactInfo({
                    email: email,
                    mobile_number: `${mobile_number}`,
                    dial_code: dial_code,
                    country_code: country_code,
                  });
                  setEmailVerficationRequired(email_verified_at1);
                  setImpIds({
                    ...impIds,
                    uuid: data?.uuid,
                    business_uuid: data?.business_uuid,
                  });
                  localStorage.setItem("x-info-id", data?.basic_info_uuid);
                  if (email_verified_at1) {
                    setShow(true);
                  } else {
                    setShowMissingFieldsModal(false);
                  }
                }}
                emailVerified={emailVerified}
              />
            )}

          {login_type?.toLocaleLowerCase() ===
            LOGIN_TYPE.INVESTOR?.toLocaleLowerCase() &&
            section === "basic_details" && (
              <BasicDetails_INVESTOR
                from="FROM_PROFILE_ANALYSIS"
                impIds={impIds}
                handleNext={(
                  data: any,
                  email: string,
                  mobile_number: string,
                  dial_code: string,
                  // mobile_verified_at1: any,
                  email_verified_at1: any,
                  country_code: string,
                ) => {
                  setContactInfo({
                    email: email,
                    mobile_number: mobile_number ? `${mobile_number}` : "",
                    dial_code: dial_code,
                    country_code: country_code,
                  });
                  setEmailVerficationRequired(email_verified_at1);
                  setImpIds({
                    ...impIds,
                    uuid: data?.uuid,
                    business_uuid: data?.business_uuid,
                  });
                  localStorage.setItem("x-info-id", data?.basic_info_uuid);
                  if (email_verified_at1) {
                    setShow(true);
                  } else {
                    setShowMissingFieldsModal(false);
                  }
                }}
                emptyImpKeys={() => {
                  setImpIds((impIds: RegistrationIds) => ({
                    ...impIds,
                    uuid: "",
                    business_uuid: "",
                  }));
                }}
                fields_to_improve={fields_to_improve}
              />
            )}

          {account_type?.toLocaleLowerCase() === "want_to_sell" &&
            section === "basic_details" && (
              <BasicDetailsWantToSell
                impIds={impIds}
                handleNext={(
                  data: any,
                  email: string,
                  mobile_number: string,
                  dial_code: string,
                  // mobile_verified_at1: any,
                  email_verified_at1: any,
                  country_code: string,
                ) => {
                  setContactInfo({
                    email: email,
                    mobile_number: mobile_number ? `${mobile_number}` : "  ",
                    dial_code: dial_code,
                    country_code: country_code,
                  });

                  setEmailVerficationRequired(email_verified_at1);
                  // setMobileVerficationRequired(mobile_verified_at1);

                  setImpIds({
                    ...impIds,
                    uuid: data?.uuid,
                    business_uuid: data?.business_uuid,
                  });
                  localStorage.setItem("x-info-id", data?.basic_info_uuid);
                  if (email_verified_at1) {
                    setShow(true);
                  } else {
                    setShowMissingFieldsModal(false);
                  }
                }}
                fields_to_improve={fields_to_improve}
                from="FROM_PROFILE_ANALYSIS"
              />
            )}

          {account_type?.toLocaleLowerCase() === "want_to_grow" &&
            section === "basic_details" && (
              <BusinessDetailsWantToGrow
                disabled={undefined}
                key={""}
                impIds={impIds}
                from="FROM_PROFILE_ANALYSIS"
                fields_to_improve={fields_to_improve}
                handleNext={(
                  data: any,
                  email: string,
                  mobile_number: string,
                  dial_code: string,
                  // mobile_verified_at1: any,
                  email_verified_at1: any,
                  country_code: string,
                ) => {
                  setContactInfo({
                    email: email,
                    mobile_number: mobile_number ? `${mobile_number}` : "",
                    dial_code: dial_code,
                    country_code: country_code,
                  });
                  setEmailVerficationRequired(email_verified_at1);
                  setImpIds({
                    ...impIds,
                    uuid: data?.uuid,
                    business_uuid: data?.business_uuid,
                  });
                  localStorage.setItem("x-info-id", data?.basic_info_uuid);
                  if (email_verified_at1) {
                    setShow(true);
                  }
                  setShowMissingFieldsModal(false);
                }}
              />
            )}

          {account_type?.toLocaleLowerCase() ===
            ACCOUNT_TYPE.INVESTMENT?.toLocaleLowerCase() &&
            section === "business_info" && (
              <BusinessDetails
                impIds={impIds}
                from="FROM_PROFILE_ANALYSIS"
                fields_to_improve={fields_to_improve}
                handleNext={() => {
                  setShowMissingFieldsModal(false);
                }}
              />
            )}
          {account_type?.toLocaleLowerCase() === "want_to_sell" &&
            section === "business_info" && (
              <BusinessDetails_WantToSell
                impIds={impIds}
                handleNext={() => {
                  setShowMissingFieldsModal(false);
                }}
                from="FROM_PROFILE_ANALYSIS"
                fields_to_improve={fields_to_improve}
              />
            )}

          {account_type?.toLocaleLowerCase() ===
            ACCOUNT_TYPE.INVESTMENT?.toLocaleLowerCase() &&
            section === "documents" && (
              <DocumentDetails
                from="FROM_PROFILE_ANALYSIS"
                impIds={impIds}
                handleNext={() => {
                  setShowMissingFieldsModal(false);
                }}
              />
            )}
          {account_type?.toLocaleLowerCase() === "want_to_grow" &&
            section === "business_info" && (
              <AdditionalInfoWantToGrow
                from="FROM_PROFILE_ANALYSIS"
                impIds={impIds}
                fields_to_improve={fields_to_improve}
                handleNext={(data: any) => {
                  if (data?.uuid && data?.business_uuid)
                    setImpIds({
                      ...impIds,
                      uuid: data?.uuid,
                      business_uuid: data?.business_uuid,
                    });
                  setShowMissingFieldsModal(false);
                }}
              />
            )}

          {login_type?.toLocaleLowerCase() ===
            LOGIN_TYPE.INVESTOR?.toLocaleLowerCase() &&
            section === "documents" && (
              <DocumentsDetails_INVESTOR
                impIds={impIds}
                handleNext={(data: any) => {
                  setShowMissingFieldsModal(false);
                }}
              />
            )}

          {account_type?.toLocaleLowerCase() === "want_to_grow" &&
            section === "documents" && (
              <DocumentDetailsWantToGrow
                from="FROM_PROFILE_ANALYSIS"
                impIds={impIds}
                handleNext={(data: any) => {
                  setShowMissingFieldsModal(false);
                }}
              />
            )}

          {account_type?.toLocaleLowerCase() === "want_to_sell" &&
            section === "documents" && (
              <DocumentDetailsWantToSell
                impIds={impIds}
                handleNext={(data: any) => {
                  setShowMissingFieldsModal(false);
                }}
              />
            )}

          {account_type?.toLocaleLowerCase() ===
            ACCOUNT_TYPE.INVESTMENT?.toLocaleLowerCase() &&
            section === "finance" && (
              <FinanceDetails
                impIds={impIds}
                fields_to_improve={fields_to_improve}
                handleNext={(data: string) => {
                  setShowMissingFieldsModal(false);
                }}
                from="FROM_PROFILE_ANALYSIS"
              />
            )}

          {login_type?.toLocaleLowerCase() ===
            LOGIN_TYPE.INVESTOR?.toLocaleLowerCase() &&
            section === "finance" && (
              <FinanceDetails_INVESTOR
                impIds={impIds}
                handleNext={(data: string) => setShowMissingFieldsModal(false)}
                from="FROM_PROFILE_ANALYSIS"
                fields_to_improve={fields_to_improve}
              />
            )}
        </Offcanvas.Body>
      </Offcanvas>
      {show && (
        <VerifyOTP
          action="verify-otp"
          contactInfo={contactInfo}
          show={show}
          handleHide={(flag: boolean) => {
            // if (flag) setEmailVerified(true);
            setShowMissingFieldsModal(false);
            setShow(false);
          }}
          from="PROFILE_ANALYSIS"
          emailVerify={emailVarificationRequired}
        />
      )}
    </React.Fragment>
  );
};

export default UpdateProfileInfoModal;
